jQuery(document).ready(function ($) {
	/*let hidden_elem = $('#tab-description p span[id*="more-"]').parent().nextAll('p');
	hidden_elem.wrapAll('<div class="hidden-elements" />');

	let hidden_wrapper = $('.hidden-elements');
	let html = '<div id="load-more" class="load-button vet-button white medium">' + load_more.more + '</div><div id="load-less" class="load-button vet-button white medium hidden">' + load_more.less + '</div>';

	hidden_wrapper.hide().after(html);

	let load_more_btn = $('#load-more');
	let load_less_btn = $('#load-less');

	load_more_btn.click(function () {
		hidden_wrapper.slideDown({
			duration: 500,
		});
		$(this).addClass('hidden');
		load_less_btn.removeClass('hidden');
	});

	load_less_btn.click(function () {
		$('html, body').animate({
			scrollTop: hidden_wrapper.offset().top - (window.innerHeight / 2),
		}, 500);
		hidden_wrapper.slideUp({
			duration: 500,
		});
		$(this).addClass('hidden');
		load_more_btn.removeClass('hidden');
	});*/
});